/* DGA nieuwe huisstijl: pijlknoppen van de carrousels links en rechts naast de blokken.
   Zet de rail (.dgb-rail) in een kader en verplaatst de bestaande twee knoppen uit .dgb-arrows naar de zijkanten
   van dat kader. Het zijn dezelfde knoppen, dus ze blijven precies zo werken (vorige/volgende, aria-labels).
   Stond de knoppenrij in een eigen omhulsel zonder andere inhoud, dan verdwijnt dat omhulsel ook (het had een
   negatieve marge om naast de introtekst te staan en zou de blokken anders tegen de tekst aan trekken).
   Stijl en positie in dga-brand-carrousel.css. Wordt geladen op alle WS2.0-templates (snippets/meta-tags.liquid). */
(function(){
  function run(){
    [].forEach.call(document.querySelectorAll('.dgb-arrows'),function(ar){
      if(ar.dataset.pgSide)return;
      var wrap=ar.closest('.dgb-wrap');if(!wrap)return;
      var rail=wrap.querySelector('.dgb-rail');if(!rail)return;
      var btns=ar.querySelectorAll('.dgb-arrow');if(btns.length<2)return;
      ar.dataset.pgSide='1';
      var box=document.createElement('div');box.className='pg-rail-box';
      rail.parentNode.insertBefore(box,rail);box.appendChild(rail);
      btns[0].classList.add('pg-side','pg-side--prev');btns[1].classList.add('pg-side','pg-side--next');
      box.appendChild(btns[0]);box.appendChild(btns[1]);
      ar.classList.add('pg-side-done');
      var p=ar.parentElement;
      if(p&&p!==wrap&&p.children.length===1&&!(p.textContent||'').trim())p.classList.add('pg-side-empty');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
